










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import { PublishedApp } from '../shared/models';
import { FacebookApi } from './services/facebookAppApi';
import { messengerApi } from './services/messengerApi';
import { instagramApi } from './services/instagramApi';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import Toast from '@/shared/services/toast';
import { fbGetSdk, fbLogin, fbLogout, fbGetLoginStatus } from './services/messengerSdkWrapper';
import { FacebookPage, MessengerInstalledApp, InstallMessengerRequest } from './models';
import {config} from '@/config/config';

interface LoginScope {
	scope: string;
}

interface LoginOptions {
	messenger: LoginScope;
	instagram: LoginScope;
}

@Component({
	mixins: [validationMixin],
	validations: {
		selectedPage: { required }
	}
})
export default class MessengerConfig extends Vue {
	@Getter public currentApp!: PublishedApp;
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public selectedPage: FacebookPage | null = null;
	public userPages: FacebookPage[] = [];
	public messengerApp: MessengerInstalledApp | null = null;

	public connected: boolean = false;

	public loginOptions: LoginOptions = {
		messenger: { scope: 'pages_show_list,pages_read_engagement,pages_messaging,pages_manage_metadata' },
		instagram: { scope: 'pages_show_list,pages_read_engagement,pages_manage_metadata,instagram_basic,instagram_manage_messages' }
	};

	public api: FacebookApi;

	public loginInProgress: boolean = false;
	public actionInProgress: boolean = false;
	public loadingPages: boolean = false;

	public created() {
		this.api = this.currentApp.id === 'instagram' ? instagramApi : messengerApi;
		if (this.currentApp.isInstalled) {
			this.loadFacebookLoginSdk(this.currentApp.id);
			this.api.getInstalledApp(this.currentWorkspace.id)
				.then((messengerApp: MessengerInstalledApp) => {
					this.messengerApp = messengerApp;

					if (messengerApp) {
						this.selectedPage = {
							access_token: '',
							id: messengerApp.pageId,
							name: messengerApp.pageName
						};
					}
				}).catch(err => {
					// if it's not found, then we haven't installed the bt app fully, so let them fill in the form
					if (err.status !== 404) {
						// show error state...
					}
				}).finally(() => {
					this.$emit('loaded');
				});
		} else {
			this.$emit('loaded');
		}
	}

	public destroyed() {
		if (!this.connected) {
			return;
		}
		fbLogout();
	}

	public loadFacebookLoginSdk(currentApp: string) {
	  const appId = currentApp === 'instagram' ? config().instagramAppId : config().facebookAppId;
		 fbGetSdk(appId).then(() => {
			fbGetLoginStatus().then((res: any) => {
				if (res.status === 'connected') {
					this.onConnected(res.authResponse.accessToken);
				}
			});
		});
	}

	public hasMessengerInstalledApp() {
		return this.messengerApp !== null;
	}

	public logout() {
		if (!this.connected) {
			return;
		}

		fbLogout().then(() => {
			fbGetLoginStatus().then((res: any) => {
				if (res.status !== 'connected') {
					this.connected = false;
				}
			});
		});
	}

	public login() {
		this.loginInProgress = true;
		const loginScope = this.loginOptions[this.currentApp.id as keyof LoginOptions].scope;
		fbLogin(loginScope).then((res: any) => {
			if (res.status === 'connected') {
				this.onConnected(res.authResponse.accessToken);
			}
		}).finally(() => {
			this.loginInProgress = false;
		});
	}

	public onConnected(authToken: string) {
		this.connected = true;
		this.getFacebookPages(authToken);
	}

	public getFacebookPages(authToken: string) {
		this.loadingPages = true;
		this.api.getUserPages(authToken)
			.then((pages: FacebookPage[]) => {
				this.userPages = pages;
			})
			.finally(() => this.loadingPages = false);
	}

	public save() {
		if (this.actionInProgress) {
			return;
		}

		if (!this.selectedPage) {
			return;
		}

		this.actionInProgress = true;

		const request = {
			installId: this.currentApp.installedAppId,
			workspaceId: this.currentWorkspace.id,
			pageId: this.selectedPage.id,
			pageName: this.selectedPage.name,
			pageAccessToken: this.selectedPage.access_token
		} as InstallMessengerRequest;

		this.api.install(request)
			.then(() => this.$emit('configSaved'))
			.catch((err) => Toast.showError(err.message))
			.finally(() => this.actionInProgress = false);
	}

	public cancel() {
		this.$router.push({ name: 'apps' });
	}

}
